import Homepage from './pages/Homepage'; // Import your Homepage component

function App() {
  return (
    <Homepage />
  );
}

export default App;